import { useCallback } from "react";
import { useUpdateDesignProject } from "../api/useUpdateDesignProject";

export function useUpdateWithDeliveryEstimates() {
  const updateProject = useUpdateDesignProject();

  // Delivery estimates are fully handled by useDeliveryDateSync which
  // triggers on optimal DC stock boundary crossings and page load.
  // This hook now only wraps the design project update.
  const handleUpdateWithDeliveryEstimates = useCallback(
    async (updateParams: Parameters<typeof updateProject.mutate>[0]) => {
      try {
        return await updateProject.mutateAsync(updateParams);
      } catch (error) {
        console.error("Error updating design project:", error);
        window.Honeybadger?.notify("Error updating design project", {
          params: {
            error: error instanceof Error ? error.message : String(error),
            error_object: error instanceof Error ? error.toString() : String(error),
            stack_trace: error instanceof Error ? error.stack : null,
            hook: "useUpdateWithDeliveryEstimates"
          }
        });
        throw error;
      }
    },
    [updateProject]
  );

  return {
    mutate: handleUpdateWithDeliveryEstimates,
    mutateAsync: handleUpdateWithDeliveryEstimates,
    isPending: updateProject.isPending,
    isSuccess: updateProject.isSuccess,
    isError: updateProject.isError,
    error: updateProject.error,
    data: updateProject.data,
    status: updateProject.status,
    reset: () => {
      updateProject.reset();
    }
  };
}
